import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import StatTile from '../../../../components/ui/tiles/statTile';
import { getAumStats } from '../../../../redux/aum/aum.slice';
import formatMoney from '../../../../helpers/formatMoneyHelper';

function BookAnalysisStats() {
  const dispatch = useDispatch();

  const officeId = useSelector((state) => state.auth.user.tenant_id);
  const { businessDays } = useSelector((state) => state.businessDay);

  const latestBalanceDate = businessDays?.date;

  const { aumStats, bookAnalysisUI } = useSelector((state) => state.aum);

  useEffect(() => {
    if (!latestBalanceDate) return;

    const selectedDate = bookAnalysisUI?.isMonthEnd
      ? bookAnalysisUI.selectedMonth
      : latestBalanceDate;

    dispatch(
      getAumStats({
        toDate: selectedDate
      })
    );
  }, [
    dispatch,
    officeId,
    latestBalanceDate,
    bookAnalysisUI?.selectedMonth,
    bookAnalysisUI?.isMonthEnd
  ]);

  const mtdAmount = aumStats?.mtd?.growthAmount ?? 0;
  const mtdPercentage = (aumStats?.mtd?.growthPercentage ?? 0) * 100;

  const ytdAmount = aumStats?.ytd?.growthAmount ?? 0;
  const ytdPercentage = (aumStats?.ytd?.growthPercentage ?? 0) * 100;

  const stats = [
    {
      title: 'MTD Growth',
      value: formatMoney(Math.abs(mtdAmount)),
      change: `${Math.abs(mtdPercentage).toFixed(2)}%`,
      trend: mtdPercentage < 0 ? 'down' : 'up'
    },
    {
      title: 'YTD Growth',
      value: formatMoney(Math.abs(ytdAmount)),
      change: `${Math.abs(ytdPercentage).toFixed(2)}%`,
      trend: ytdPercentage < 0 ? 'down' : 'up'
    },
    {
      title: 'Platforms / MANCOs',
      value: (aumStats?.totalProviders ?? 0).toLocaleString(),
      changeLabel: ''
    }
  ];

  return (
    <Box
      display="grid"
      gridTemplateColumns={{
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)'
      }}
      gap={2}
      mt={3}>
      {stats.map((stat) => (
        <StatTile key={stat.title} {...stat} />
      ))}
    </Box>
  );
}

export default BookAnalysisStats;
